import React from "react"
import { AffiliationSlider } from "./AffiliationSlider"
import { AffiliationSliderLogo } from "./affiliation-slider-types"

interface AffiliationSliderGlobalFooter {
  logo_slider: {
    logo_slider: {
      eyebrow_text?: string | null
      heading?: string | null
      logo_slider_description?: {
        data: string
      } | null
      logos?: AffiliationSliderLogo[]
      sub_heading?: string | null
    }
  }
}

export const AffiliationSliderGlobalFooter = ({
  logo_slider,
}: AffiliationSliderGlobalFooter) => {
  const logoSlider = logo_slider?.logo_slider
  return <AffiliationSlider {...logoSlider} />
}
